import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { aiNoticeMessages } from './aiNoticeMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from '../Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface AiVideoNoticeProps {
  /** A channel of the post is posted by hand: Music24 cannot set its label, the artist must. */
  hasManualChannel?: boolean;
}

/**
 * The fixed notice next to a post whose media holds AI-generated footage. It has no switch: the
 * label is locked on. It uses the note strip of the Composer (`ComposerChannelNote`).
 */
const AiVideoNoticeComponent: React.FC<AiVideoNoticeProps> = ({ hasManualChannel = false }) => {
  const intl = useIntl();

  return (
    <div className={styles.infoStrip} role="note" data-testid="ai-video-notice">
      <span>{withBrandWord(intl.formatMessage(aiNoticeMessages.text))}</span>
      {hasManualChannel ? (
        <span data-testid="ai-video-notice-manual">{intl.formatMessage(aiNoticeMessages.manual)}</span>
      ) : null}
    </div>
  );
};

export const AiVideoNotice = TypedMemo(AiVideoNoticeComponent);
